import script from "./AcessibilityItems.vue?vue&type=script&setup=true&lang=js"
export * from "./AcessibilityItems.vue?vue&type=script&setup=true&lang=js"

import "./AcessibilityItems.vue?vue&type=style&index=0&id=57b743d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57b743d6"]])

export default __exports__